import { differenceInMonths, format } from 'date-fns'

export function formatDate(dateString: string | undefined): string {
    if (!dateString) return 'present'
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
    }).format(date)
}

export function formatDateAllInfo(dateString: string | undefined): string {
    if (!dateString) return 'N/A'
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    }).format(date)
}

export function formatDuration(
    startDate?: Date | string,
    endDate?: Date | string,
): { fromTo: string; duration: string } {
    if (!startDate)
        return {
            fromTo: 'N/A',
            duration: '',
        }

    const start = new Date(startDate)
    const isEndDateProvided = Boolean(endDate)
    const end = isEndDateProvided ? new Date(endDate!) : new Date() // Use today's date if endDate is falsey

    const startFormatted = format(start, 'MMM yyyy')
    const endFormatted = isEndDateProvided ? format(end, 'MMM yyyy') : 'present' // Use "present" if endDate is falsey

    const totalMonths = differenceInMonths(end, start) + 1 // Include start month
    const years = Math.floor(totalMonths / 12)
    const months = totalMonths % 12

    let duration = ''
    if (years > 0) {
        duration += `${years} year${years > 1 ? 's' : ''}`
    }
    if (months > 0) {
        duration += `${duration ? ', ' : ''}${months} month${
            months > 1 ? 's' : ''
        }`
    }

    return {
        fromTo: `${startFormatted} - ${endFormatted}`,
        duration: duration,
    }
}
